class CollectionPagination {
  constructor() {
    this.initAjaxinate();
  }

  initAjaxinate() {
    if (typeof Ajaxinate !== 'undefined') {
      new Ajaxinate({
        container: '.ajaxinate-container',      // Product grid container
        pagination: '#AjaxinatePagination',    // Pagination wrapper
        method: 'scroll',                       // Or 'click'
        loadingText: 'Loading'
      });
    } else {
      console.warn('Ajaxinate is not defined.');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionPagination();
});

$(document).ready(function() {  
     $(".scroll-prompt.cat-link").click(function() {
        $('html, body').animate({
            scrollTop: $(".circle__container").offset().top - 64
        }, 1000);
    });
    $('#menu-drawer .theater__top--links .women__drawer_menu').click(function() {
      $(this).addClass('active').siblings().removeClass('active');
      $('.menu-tab-content .women-menu').addClass('active').siblings().removeClass('active');
    }); 
    $('#menu-drawer .theater__top--links .men__drawer_menu').click(function() {
      $(this).addClass('active').siblings().removeClass('active');
      $('.menu-tab-content .men-menu').addClass('active').siblings().removeClass('active');
    }); 
    const accordionJ = setInterval(function() {
      if ( $('.accordion_container .accordion_head').length){
        $(".accordion_container .accordion_body").slideUp();
        $(".accordion_container  .acc__arrow").removeClass("arrow_down");
        $('.accordion_container .accordion_head').click(function() {
          $(this).find(".acc__arrow").toggleClass("arrow_down");
          $(this).next(".accordion_body").slideToggle();
        });
        clearInterval(accordionJ);
      }
    },1000);

    const $slider = $('.slider-for-lookbooks');

      $slider.on('init', function(event, slick) {
        $(this).closest('.slick-wrapper-lookbook-main').addClass('is-loaded');
      });
      // Initialize slick
      $slider.not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 3000,
      });

      $("body:not(.template-page-custom-landing) .home-circle-j").slick({
        slidesToShow: 8,
        infinite:true,
        slidesToScroll: 4,
        autoplay: false,
        dots: false,
        arrows: true,
        responsive: [
        {
          breakpoint: 1420,
              settings: {
                slidesToShow: 6,
              }
          },
          {
          breakpoint: 1300,
              settings: {
                slidesToShow: 5,
              }
          },
              {
          breakpoint: 950,
              settings: {
                slidesToShow: 4,
              }
          }
        ]
      });
      $(".template-page-custom-landing .home-circle-j").slick({
        slidesToShow: 9,
        infinite:true,
        slidesToScroll: 4,
        autoplay: false,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 1420,
                settings: {
                  slidesToShow: 6,
                }
            },
            {
            breakpoint: 1300,
                settings: {
                  slidesToShow: 5,
                }
            },
                {
            breakpoint: 950,
                settings: {
                  slidesToShow: 4,
                }
            }
        ]
      });
      $(".featured-brand-slider").slick({
          infinite: true,
          slidesToShow:5,
          slidesToScroll:1,
          dots:false,
          arrows:false,
          autoplay: true,
          responsive: [{
          breakpoint: 1199,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 991,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
              }
          },
          {
            breakpoint: 767,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
          }]
      });
      $(".circle__container .home-circle-custom-j").slick({
        slidesToShow: 8,
        infinite:true,
        slidesToScroll: 4,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 1420,
                settings: {
                  slidesToShow: 6,
                }
            },
            {
            breakpoint: 1300,
                settings: {
                  slidesToShow: 5,
                }
            },
                {
            breakpoint: 950,
                settings: {
                    arrows: false,
                    infinite: false,
                    slidesToShow: 4.4,
                    slidesToScroll: 1
                  }
            }
          ]
      }); 
      $(".lookbook-slider-with-hotspots .slider-hotspots-inner").slick({
        slidesToShow: 4,
        infinite:true,
        slidesToScroll: 4,
        autoplay: true,
        dots: false,
        arrows: false,
        responsive: [
            {
            breakpoint: 1300,
                settings: {
                  slidesToShow: 3,
                }
            },
                {
            breakpoint: 950,
                settings: {
                  slidesToShow: 1,
                }
            }
        ]
      }); 
      $(".product-media-modal .product-media-modal__content .zoom-slider-wrapper").slick({
        slidesToShow: 1,
        infinite:true,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        asNavFor: '.product-media-modal .product-media-modal__content .thumbnails-wrapper',
      }); 
      $(".product-media-modal .product-media-modal__content .thumbnails-wrapper").slick({
        slidesToShow: 5,
        infinite:true,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        asNavFor: '.product-media-modal .product-media-modal__content .zoom-slider-wrapper',
        focusOnSelect: true,
        responsive: [
            {
              breakpoint: 1420,
                  settings: {
                    slidesToShow: 5,
                  }
              },
              {
              breakpoint: 950,
                  settings: {
                      arrows: false,
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
              }
            ]
      }); 
      $('.circle_categories_w_filter .circle__filter_a').click(function(e){
          if($(this).hasClass('other_circle_target')){
            var get_tag = $(this).data('tag');
            $('.circle_displayed_products .grid-display__item').removeClass('active');
              $('.circle_displayed_products .grid-display__item.target_' + get_tag).addClass('active');
          }else{
            $('.circle_displayed_products .grid-display__item').addClass('active');
          }
              $('.circle__filter_inner_div').removeClass('active_cat');
            $(this).parent().find('.circle__filter_inner_div').addClass('active_cat');
      }); 
      $(".homebook-slider2 .home_lookbook-carousel").slick({
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots:false,
        autoplay: false,
        speed: 500,
        arrows:true,
        infinite: true,
        prevArrow: '<div class="prev-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
        nextArrow: '<div class="next-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
        responsive: [
            {
            breakpoint: 1440,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
          },
          {
          breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots:false,
                arrows:false,
                infinite: true,
            }
        },
        {
          breakpoint: 767,
          settings: "unslick"
        }]
      });
      $(".lookbook-slider-c ").slick({
        slidesToShow: 1,
        infinite:true,
        slidesToScroll: 1,
        autoplay: true,
        dots: true,
        arrows: false
      }); 
      $('.similar_products_grid').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        dots:false,
        autoplay: false,
        speed: 500,
        arrows:true,
        infinite: true,
        prevArrow: '<div class="prev-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
        nextArrow: '<div class="next-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
        responsive: [
          
          {
          breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots:false,
                infinite: true,
            }
        },
        {
          breakpoint: 767,
          settings: "unslick"
              // settings: {
              //    slidesToShow: 2.5,
              //    slidesToScroll: 2,
              //    dots:false,
              //    arrows:false,
              //    infinite: true,
              //   centerPadding: '12px',
              // }
        }]
      });

        // Open
      $('body').on('click', '.product__info-wrapper .size_guide_texture.above__addtocart .size_guide_popup', function() {
        $(' .product__info-wrapper .popup_size_guide').show();
        $('body').addClass('open__sizeguide');
      });
      // Close
      $('body').on('click', ' .product__info-wrapper .size_guide_close', function() {
        $('.popup_size_guide').hide();
        $('body').removeClass('open__sizeguide');
      });
      $('body').on('click', ' .size_guide_shoes .size_guide_shoes_link', function() {
        $(this).next().addClass("active");
      });
      $('body').on('click', '.size_guide_shoes .shoes-size-chart-popup .header-top-wrap .close-wrap', function() {
        $(this).parents(".shoes-size-chart-popup").removeClass("active");
      });
      $('.product_color__links.product-form__option-swatches-wrapper.metafield_swatch').each(function() {
        if (!$(this).html().trim()) {
          $(this).hide();
        }
      });
        if($(window).width() > 768) {
            const slider = document.querySelector('.home_lookbook-carousel');
            let isDown = false;
            let startX;
            let scrollLeft;
          
            slider.addEventListener('mousedown', (e) => {
              isDown = true;
              slider.classList.add('active');
              startX = e.pageX - slider.offsetLeft;
              scrollLeft = slider.scrollLeft;
              // console.log("erreerre", scrollLeft)
            });
          
            slider.addEventListener('mouseleave', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('mouseup', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('mousemove', (e) => {
              if (!isDown) return;  // stop the fn from running
              e.preventDefault();
              const x = e.pageX - slider.offsetLeft;
              const walk = (x - startX) * 2;
              slider.scrollLeft = scrollLeft - walk;
              
              // console.log('sdsd', scrollLeft)
              // console.log(slider.scrollLeft)
            });
        
        
            //   touchEvents
        
            slider.addEventListener('touchstart', (e) => {
              isDown = true;
              slider.classList.add('active');
              startX = e.pageX - slider.offsetLeft;
              scrollLeft = slider.scrollLeft;
            });
          
            slider.addEventListener('touchend', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('touchcancel', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('touchmove', (e) => {
              if (!isDown) return;  // stop the fn from running
              e.preventDefault();
              const x = e.pageX - slider.offsetLeft;
              const walk = (x - startX) * 2;
              slider.scrollLeft = scrollLeft - walk;
            });
        }
        if ($(window).width() < 768) {
          $('.custom-image-video-wrap:not(.trending)  .home_lookbook-carousel').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots:true,
                autoplay:true,
                infinite: true, 
          });
        }
        $('.home_lookbook-carousel .slick-slide video').trigger('pause');
        $('.home_lookbook-carousel .slick-slide.slick-active video').trigger('play');
        $('.home_lookbook-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('.home_lookbook-carousel .slick-slide video').trigger('pause');
        $('.home_lookbook-carousel .slick-slide.slick-active video').trigger('play');
        });
        if($(window).width() < 768) {
          $('.footer .footer__content-top .footer-block__heading').click(function() {
              $(this).toggleClass("active");
              $(this).siblings(".footer-block__details-content").toggle();
          }); 
        }
      
        $(".featured-home-slider").on('init', function(event, slick) {
          $(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
          $('.current').text(slick.currentSlide + 1);
          $('.total').text(slick.slideCount);
          }).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots:false,
            autoplay: false,
            speed: 500,
            arrows:false,
            infinite: true,
            responsive: [
              {
              breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots:false,
                    infinite: true
                }
            },
              {
              breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots:false,
                    infinite: true
                }
            },
            {
              breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:false,
                    infinite: true
                }
            }]
          })
          .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                $('.current').text(nextSlide + 1);
        });
        $(".lookbook-slider-with-hotspots .shoppable-item__hotspot-position").click(function() {
          $(this).parent().toggleClass("active");
        });
      }); 
      function isMobileDevice() {
          return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      }
      if (isMobileDevice()) {

          if (window.location.href.includes('products')) {
            /* document.querySelectorAll('.product__modal-opener').forEach(element => {
                element.style.pointerEvents = 'none';
              }); */
              let scale = 1;
              let lastScale = 1;
              let initialDistance = 0;

              const zoomableImages = document.querySelectorAll('.product__media .image-magnify-lightbox');
            
              zoomableImages.forEach(image => {
                  image.scale = 1;
                  image.lastScale = 1;
                  // console.log(image);
                  image.addEventListener('click', function(event) {
                  // console.log("Clicked");
                      event.preventDefault(); 
                  });
                  image.addEventListener('touchstart', handleTouchStart);
                  image.addEventListener('touchmove', handleTouchMove);
                  image.addEventListener('touchend', handleTouchEnd);
              });

              function handleTouchStart(event) {
              
                  if (event.touches.length > 1) {
                      const image = event.target;
                      initialDistance = getDistance(event.touches);
                      image.lastScale = image.scale; 
                  }
              }

              function handleTouchMove(event) {
                  // Allow scrolling with one finger and prevent default only for pinch zoom
                  if (event.touches.length > 1) {
                      event.preventDefault(); // Prevent scrolling for pinch zoom
                      const image = event.target;
                      const currentDistance = getDistance(event.touches);
                      image.scale = image.lastScale * (currentDistance / initialDistance);
                      image.style.transform = `scale(${image.scale})`;
                  }
              }

              function handleTouchEnd(event) {
                  // If all touches are lifted, reset the zoom to normal
                  if (event.touches.length === 0) {
                      const image = event.target;
                      image.style.transition = 'transform 0.2s'; // Smooth transition back to original scale
                      image.style.transform = `scale(1)`; // Reset zoom to original scale
                      image.scale = 1; // Reset scale variable
                      image.lastScale = 1; // Reset lastScale variable
                  }
              }

              function getDistance(touches) {
                  const dx = touches[0].pageX - touches[1].pageX;
                  const dy = touches[0].pageY - touches[1].pageY;
                  return Math.sqrt(dx * dx + dy * dy);
              }
          }
      }
      /*================ start newsletter popup =========*/
      var get_storage_popup = localStorage.getItem("Newsletter-popup");
      var window_path = window.location.href;
      
      if(get_storage_popup == null){
      
        if(window_path.includes('#newsletterPopupForm')){
            if(window_path.includes('?customer_posted=true')){
              setTimeout(function(){
                $('.newsletter_popup').addClass('visible');
            },2000);
            }else{
              setTimeout(function(){
                $('.newsletter_popup').addClass('visible');
              },10000);
            }
        }
        else{
          setTimeout(function(){
                $('.newsletter_popup').addClass('visible');
              },10000);
        }
      } 
  
    $('.newsletter_popup .popup__close').click(function(){
      localStorage.setItem("Newsletter-popup", "true");
      $(this).parents('.newsletter_popup').removeClass('visible');
    });
    /* THTR-DEV-APR-364 Newsletter Popup */
    $('.copy-trigger').on('click', function(){
      var code = $('#couponCode').text();
      navigator.clipboard.writeText(code).then(function() {
        const icon = $('.copy-icon svg');
        const originalIcon = icon.html();

        // Swap to checkmark SVG
        icon.replaceWith(`
          <svg class="copied-check" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#1E1D66" viewBox="0 0 24 24">
            <path d="M20.285 6.709l-11.285 11.291-5.285-5.291 1.414-1.414 3.871 3.877 9.871-9.877z"/>
          </svg>
        `);

        setTimeout(() => {
          $('.copied-check').replaceWith(`
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#1E1D66" viewBox="0 0 24 24">
              <path d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12V1z"/>
              <path d="M20 5H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 18H8V7h12v16z"/>
            </svg>
          `);
        }, 1500);
      });
    });
    /*  Newsletter Popup */  
    /*============= end newsletter popup =============*/

    /* For open OTP login Popup */
    $(".login-popup-link").click(function() {
        localStorage.setItem("lastest_refer",window.location.href);
        $(".login-popup").addClass("active");
        $(".overlay-login-popup").addClass("active");
       return false;
      });
       $(".login-popup .close-btn").click(function() {
        $(".login-popup").removeClass("active");
        $(".overlay-login-popup").removeClass("active");
    });
    /* End For open OTP login Popup */
    // Play video on click
    document.addEventListener("DOMContentLoaded", function () {
        const playButtons = document.querySelectorAll(".play-video");
        playButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            const parent = button.closest(".slider-inner");
            const video = parent.querySelector("video");

            if (video) {
              video.setAttribute("autoplay", true);
              video.setAttribute("muted", true); // Optional: Needed for autoplay to work in some browsers
              video.play();
              button.style.display = "none"; // Hide play button after playing
            }
          });
        });
    });
    // Play video on click

    // For select Size
    let attempts = 0;
    const maxAttempts = 5; // will check for 30 seconds (50 * 600ms)
    const intervalIdJ = setInterval(function () {
      attempts++;
      const now = new Date().toLocaleTimeString();
      const notifyButton = document.getElementById('peppy-notify-me-button-container');
      if (notifyButton) {
        notifyButton.style.display = 'none';
        //clearInterval(intervalId);
      }

      if (attempts >= maxAttempts) {
        clearInterval(intervalIdJ);
      }
    },400);
    $(document).on('click', '.chip-wrapper input[type="radio"]', function () {
      var $productOverlayBtn = $('.addtocart__btn__overlay');
      if ($productOverlayBtn.length) {
        $productOverlayBtn.removeClass('selectsize_show');
      }
      setTimeout(() => {
            const $addToCartBtn = $('.product-form__submit.button');
            if (!$addToCartBtn.length) return;
          
            const isDisabled = $addToCartBtn.is(':disabled');
          
            const $buyBtn = $('.template-product .shopify-payment-button');
            const $notifyButton = $('.notify_me_btn');
            if (!isDisabled) {
              $buyBtn.show();
              $notifyButton.hide();
            } else {
              $buyBtn.hide();
              $notifyButton.show();
            }
        }, 1000);
    });

    // End
    // custom Menu drawer js

    $(document).ready(function() {
      $('header-drawer #menu-drawer .back-close-wrap .close-wrap').click(function() {
        $('.menu-drawer-container').removeClass("menu-opening");
        $('.menu-drawer-container').removeAttr('open');
        $('.header__icon--menu').attr('aria-expanded', 'false');
        $('.section-header').removeClass("menu-open");
        $('body').removeClass("overflow-hidden-desktop");
      });
      $('body').on('click', '.size_guide_shoes .switch', function () {
        $(this).toggleClass("active");
        const isActive = $(this).hasClass("active");

        // remove active from both first
        $(".size_guide_shoes .size-chart-shapewear .table").removeClass("active");
        $(".size_guide_shoes .size-toggle span").removeClass("active");

        if (isActive) {
          // when switch has active
          $(".size_guide_shoes .size-toggle span.on-label").addClass("active");
          $(".size_guide_shoes .size-chart-shapewear .table.in-inches").addClass("active");
        } else {
          // when switch does NOT have active
          $(".size_guide_shoes .size-toggle span.off-label").addClass("active");
          $(".size_guide_shoes .size-chart-shapewear .table.in-cm").addClass("active");
        }
      });
    });
    if ($('header-drawer #menu-drawer .submenu-open').length) {
      $('header-drawer #menu-drawer .back-close-wrap').addClass('active');
    } else {
      $('header-drawer #menu-drawer .back-close-wrap').removeClass('active');
    }

    $(document).on('click', '.sticky_product_bar .sticky__btns button', function () {
      if ($('body').hasClass('template-product-shapewear') || $('body').hasClass('template-product-winter_fur-withsizechart')) {
        $('html, body').animate({
          scrollTop: $('.product__info-wrapper').offset().top
        }, 600); // adjust duration if needed
      }
    });

    document.addEventListener("DOMContentLoaded", function () {
      const sections = document.querySelectorAll("section");
      sections.forEach((section) => {
        const loader = section.querySelector(".loader-skelton-style");
        const rebuyBox = section.querySelector(".rebuy-widgets-main");

        if (!loader || !rebuyBox) return;

        // Start loader visible
        loader.style.display = "flex";
        const observer = new MutationObserver(() => {
          if (rebuyBox.innerHTML.trim() !== "") {
            loader.style.display = "none";
            observer.disconnect();
          }
        });

        observer.observe(rebuyBox, { childList: true, subtree: true });
      });
    });

    document.addEventListener("click", function(e) {
      const target = e.target;
      // open modal
      if (target.matches("[data-open-modal]")) {
        const id = target.getAttribute("data-open-modal");
        const modal = document.querySelector(`[data-modal-id="${id}"]`);
        if (modal) {
          modal.classList.add("active");
          document.body.classList.add("modal-open");
        }
      }
      // close modal
      if (target.matches(".universal-modal__close") ||
          target.matches(".universal-modal__overlay")) {
        const modal = target.closest(".universal-modal");
        modal.classList.remove("active");
        document.body.classList.remove("modal-open");
      }
    });
      // PROMO MODAL – OPEN ONLY ONCE PER SESSION
    const promoModalShown = sessionStorage.getItem("promoModalShown");
    // Open modal
    function openUniversalModal(id) {
      const modal = document.querySelector(`[data-modal-id="${id}"]`);
      if (modal) {
        modal.classList.add("active");
        document.body.classList.add("modal-open");
      }
    }
    // Close modal
    function closeUniversalModal(id) {
      const modal = document.querySelector(`[data-modal-id="${id}"]`);
      if (modal) {
        modal.classList.remove("active");
        document.body.classList.remove("modal-open");
      }
    }
    // Close modal on clicking close button
    document.addEventListener("click", (e) => {
      // If user clicks the button OR the SVG inside the button
      if (
        e.target.classList.contains("universal-modal__close") ||
        e.target.closest(".universal-modal__close")
      ) {
        const modal = e.target.closest("[data-modal-id]");
        if (modal) {
          closeUniversalModal(modal.getAttribute("data-modal-id"));
        }
      }
    });

    // Start This Code for get product on Modal
    document.addEventListener("rebuy:cart.ready", function(e) {
      window.rebuyCartData = e.detail.cart.line_items; 
    });
    // Check if modal already shown in this session
    function hasModalShown() {
      return sessionStorage.getItem("cartModalShown") === "yes";
    }
    function updateCheckoutTotal() {

      const loader = document.querySelector(".loaderCstmStyle");
      const parentBtn = document.querySelector(".checkout-button-main");

      // show loader + add loading class
      if (parentBtn) parentBtn.classList.add("loadingMain");

      // SAFE: Get latest Rebuy cart object
      const cart = window.Rebuy?.Cart?.getCart();

      if (!cart) {
        console.error("Rebuy cart not loaded yet");
        if (parentBtn) parentBtn.classList.remove("loadingMain");
        return;
      }

      // Convert paise → rupees
      let totalAmount = (cart.total_price / 100).toFixed(2);

      // Insert total amount in modal
      const totalElement = document.querySelector(".total-payment-amount");
      if (totalElement) {
        totalElement.textContent = `₹${totalAmount}`;
      }

      // hide loader + remove loading class
      if (parentBtn) parentBtn.classList.remove("loadingMain");
    }

    // -------------------------------
    // LIVE UPDATE: whenever Rebuy cart changes
    // -------------------------------
    document.addEventListener("rebuy:cart.change", () => {
      updateCheckoutTotal();
    });


    // Function: Fetch cart items from Rebuy
    function loadCartItems(showOnLoad = true) {

      // Get Rebuy cart data
      const cart = window.Rebuy.Cart.getCart();

      // If cart empty → do nothing
      if (!cart || cart.items.length === 0) {
        console.log("Cart empty, modal will NOT open");
        return;
      }

      // If modal already shown in this session → stop
      if (hasModalShown() && showOnLoad) {
        console.log("Modal already shown this session — will NOT show again");
        return;
      }

      // Fill cart items
      let container = document.getElementById("cartItemsContainer");
      container.innerHTML = "";

      cart.items.forEach(item => {

        const liveItem = cart?.items?.find(i => i.key === item.key) || item;

        const quantity = item.quantity || 1;

        // 👉 unit prices
        let unitDiscounted = Number(
          (liveItem.discounted_price ??
          liveItem.price ??
          item.discounted_price ??
          item.price) / 100
        );

        let unitOriginal = Number(
          (liveItem.original_price ??
          liveItem.compare_at_price ??
          liveItem.price ??
          item.original_price ??
          item.compare_at_price ??
          item.price) / 100
        );

        // proper price fallback chain
        let discounted = (unitDiscounted * quantity).toFixed(2);
        let original = (unitOriginal * quantity).toFixed(2);

        let hasDiscount = Number(original) > Number(discounted);

        // Rebuy image field
        let image = item.image_url || item.image || item.product_image;

        container.innerHTML += `
          <div class="cart-item" data-key="${item.key}">
            <div class="cart-item-image-innr">
              <img src="${image}" alt="">
            </div>

            <div class="cardContentInner">
              <h2>${item.product_title} x ${quantity}</h2>

              <div class="price-style-list-main">
                <span class="mrpPriceCstm">MRP</span>
                ${hasDiscount
                  ? `<span class="discountPriceCstm">RS. ${discounted}</span>
                    <span class="regularPriceCstm">RS. ${original}</span>`
                  : `<span class="discountPriceCstm">RS. ${discounted}</span>`
                }
              </div>

            </div>

            <div class="removeButtonCard delete-cart-item-btn">
              <span class="loaderCardProduct"></span>
              <svg class="deleteBtnCartPrdct" width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.1667 4.5V12.2333C11.1667 12.6577 10.9981 13.0646 10.698 13.3647C10.398 13.6648 9.99101 13.8333 9.56667 13.8333H3.43333C3.00899 13.8333 2.60202 13.6648 2.30196 13.3647C2.0019 13.0646 1.83333 12.6577 1.83333 12.2333V4.5M9.16667 2.5V1.3C9.16667 0.86 8.80667 0.5 8.36667 0.5H4.63333C4.19333 0.5 3.83333 0.86 3.83333 1.3V2.5M9.16667 2.5H3.83333M9.16667 2.5H12.5M3.83333 2.5H0.5M6.5 6.5V10.5M8.5 6.5V10.5M4.5 6.5V10.5" 
                stroke="black" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        `;
      });

      // UPDATE full cart total from Rebuy
      updateCheckoutTotal(cart.total_price / 100);

      // Show reminder modal
      showCartModal();
    }

    document.addEventListener("rebuy:cart.ready", () => {
      setTimeout(() => {
        loadCartItems(true); 
      }, 2000);
    });

    function removeItemFromCart(key, cardElement){
      
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id:key, quantity:0 })
      })
      .then(res => res.json())
      .then(res => {

        // REMOVE CARD FROM DOM (no refresh)
        cardElement.remove();

        // AFTER remove completed
        setTimeout(()=>{

          const left = document.querySelectorAll('.cart-item').length;

          // if no product remain
          if(left === 0){
            closeCartModal();
          }

        }, 50);

      })

    }

    document.addEventListener("click", async function (e) {
      const btn = e.target.closest(".delete-cart-item-btn");
      if (!btn) return;

      const itemKey = btn.closest(".cart-item")?.getAttribute("data-key");
      if (!itemKey) return;

      // start loader
      btn.disabled = true;
      btn.classList.add("loaderDeleteAdd");

      try {
        // remove from Shopify
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: itemKey, quantity: 0 })
        });

        // remove from rebuy
        if (window.Rebuy?.Cart?.removeItem) {
          await window.Rebuy.Cart.removeItem(itemKey);
        }

        // force refresh
        if (window.Rebuy?.Cart?.refresh) {
          await window.Rebuy.Cart.refresh();
        }

        // wait 1 second 👇
        await new Promise(resolve => setTimeout(resolve, 800));

        // UI refresh
        loadCartItems(false);

        // remove UI element instantly
        document.querySelector(`.cart-item[data-key="${itemKey}"]`)?.remove();

        // close modal if empty
        if (!document.querySelector(".cart-item")) {
          setTimeout(() => {
            document.getElementById("closeCartModal")?.click();
          }, 300);
        }

      } catch (err) {
        console.error("Delete failed:", err);
      }
      setTimeout(()=>{
        const parent = document.querySelector("#cartItemsContainer");
        if(parent && parent.querySelectorAll(".cart-item").length === 0){
          document.getElementById("closeCartModal")?.click();
        }
      },10);
      // stop loader
      btn.classList.remove("loaderDeleteAdd");
      btn.disabled = false;
    });

    document.getElementById("modalCheckoutBtn").addEventListener("click", function (e) {
      e.preventDefault();

      const drawerCheckoutBtn = document.querySelector('[onclick="onCheckoutClick(this)"]');

      if (drawerCheckoutBtn) {
        onCheckoutClick(drawerCheckoutBtn);
      }
    });

    function showCartModal() {
      document.getElementById("cartReminderModal").style.display = "flex";
      document.body.style.overflow = "hidden";
      sessionStorage.setItem("cartModalShown", "yes");
    }

    document.getElementById("closeCartModal").addEventListener("click", function () {
      document.body.style.overflow = "";
      document.getElementById("cartReminderModal").style.display = "none";
    });

    // Show modal only once per session + only if cart has products
    window.addEventListener("DOMContentLoaded", () => {
      loadCartItems(true);
    });

    // End This Code for get product on Modal
    document.getElementById("modalCheckoutBtn").addEventListener("click", function (e) {
      e.preventDefault();

      const drawerCheckoutBtn = document.querySelector('[onclick="onCheckoutClick(this)"]');

      if (drawerCheckoutBtn) {
        onCheckoutClick(drawerCheckoutBtn);
      }
    });

    document.addEventListener("DOMContentLoaded", function () {

      function updateRebuySplideDots() {
        const dotsUl = document.querySelector(".rebuy-product-grid ul");

        if (!dotsUl) return false;

        const dots = dotsUl.querySelectorAll("li");
        if (dots.length === 0) return false;

        const dotWidth = (100 / dots.length) + "%";

        dots.forEach((dot) => {
          dot.style.width = dotWidth;
          dot.style.flex = "0 0 " + dotWidth;
        });

        return true;
      }

      // --- 1️⃣ Retry System (Ensures slider loads first) ---
      let tries = 0;
      let maxTries = 20; // tries for ~4 seconds

      function retryDots() {
        if (updateRebuySplideDots()) {
          return; // success
        }
        tries++;
        if (tries < maxTries) {
          setTimeout(retryDots, 200);
        }
      }
      retryDots();
      // --- 2️⃣ MutationObserver (Detect when Rebuy injects slider) ---
      const observer = new MutationObserver(() => {
        updateRebuySplideDots();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      // --- 3️⃣ Rebuy JS Event Listener (if Rebuy fires events) ---
      document.addEventListener("rebuy:cart.show", updateRebuySplideDots);
      document.addEventListener("rebuy:cart.ready", updateRebuySplideDots);
      document.addEventListener("rebuy:page.load", updateRebuySplideDots);
      document.addEventListener("rebuy:products.loaded", updateRebuySplideDots);
    });
